import { requestGet } from '@/common/request';

export interface listAllChannelRes {
  ret: string;
  msg: string;
  data: {};
}

// 查询全部平台营销频道列表
export async function listAllChannel(): Promise<listAllChannelRes> {
  return await requestGet('/channelActivity/listAllChannel');
}
